module.exports = __webpack_public_path__ + "static/media/search.d3c0a274.svg";